import React from "react";
import ReactDOM from "react-dom/client";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import "./index.css";
import App from "./App";
import theme from "./theme";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";

// Dark mode only: force the stored color mode to dark on every load so a
// previously-saved "light" value can't bring the light theme back.
try {
  window.localStorage.setItem("chakra-ui-color-mode", "dark");
} catch (e) {
  /* ignore storage errors */
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <AuthProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </AuthProvider>
    </React.StrictMode>
  </ChakraProvider>
);

reportWebVitals();
